import React from "react";
import { Col, Card, Dropdown } from "react-bootstrap";

class CollectionItem extends React.Component
{
    renderActions() {
        const { actions, position } = this.props;
        
        if (!actions || actions.length === 0) return null;

        const buttonStyle = {
            background: "none",
            border: "none",
            padding: "5px",
            cursor: "pointer",
            opacity: 0.7,
            transition: "opacity 0.2s"
        };

        // Top right position - hamburger dropdown menu
        if (position === "topRight") {
            return (
                <Dropdown style={{ position: "absolute", top: "10px", right: "10px" }}>
                    <Dropdown.Toggle 
                        variant="link" 
                        id="dropdown-basic"
                        style={{
                            background: "none",
                            border: "none",
                            padding: "5px",
                            color: "black",
                            boxShadow: "none"
                        }}
                    >
                        <i className="fas fa-bars" style={{ fontSize: "18px" }} />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {actions.map((action, index) => (
                            <Dropdown.Item 
                                key={index}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    action.onClick && action.onClick();
                                }}
                            >
                                <i className={action.image} style={{ marginRight: "8px" }} />
                                {action.label || `Action ${index + 1}`}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            );
        }

        // Bottom positions - icon buttons
        const containerStyle = {
            display: "flex",
            gap: "8px",
            marginTop: "15px",
            borderTop: "1px solid #dee2e6",
            paddingTop: "10px"
        };

        if (position === "bottomLeft") {
            containerStyle.justifyContent = "flex-start";
        } else if (position === "bottomRight") {
            containerStyle.justifyContent = "flex-end";
        } else {
            containerStyle.justifyContent = "center";
        }

        return (
            <div style={containerStyle}>
                {actions.map((action, index) => (
                    <button
                        key={index}
                        onClick={(e) => {
                            e.stopPropagation();
                            action.onClick && action.onClick();
                        }}
                        style={buttonStyle}
                        onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
                        onMouseLeave={(e) => e.currentTarget.style.opacity = 0.7}
                    >
                        <i className={action.image} style={{ fontSize: "18px", color: "black" }} />
                    </button>
                ))}
            </div>
        );
    }

    render() {
        return (
            <Col md="4" sm="6" lg="4" xl="3" xxl="2" xs="12" className="d-flex">
                <Card role="button" style={{ color: "black", boxShadow: "0.063em 0.75em 1.563em rgb(0 0 0 / 78%)", position: "relative"}} onDoubleClick={this.props.onOpen}>
                    {this.props.position === "topRight" && this.renderActions()}
                    <Card.Body style={{ textAlign: "center" }} >
                        <i className={`card-img-top ${this.props.image || "iapp-Blank-file"}`} style={{ color: this.props.imageColor || "black", fontSize: this.props.size || "60px" }} />
                        {this.props.title ? <Card.Title style={{ marginTop: "10px", textAlign: "center", fontSize: "clamp(0.875rem, 0.85vw, 0.25rem)" }}>{this.props.title || ""}</Card.Title> : ``}
                        {this.props.text ? <Card.Text style={{ fontSize: "clamp(0.5rem, 0.3vw, 0.25rem)" }}>{this.props.text || ""}</Card.Text> : ``}
                        {this.props.note ? <Card.Text>
                            <small className="text-muted">{this.props.note}</small>
                        </Card.Text>
                            : ``}
                        {this.props.position !== "topRight" && this.renderActions()}
                    </Card.Body>
                </Card>
            </Col>
        )
    }
}

export default CollectionItem;